var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 83,
    viewBox: "0 0 82 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1085 25.452L58.4167 28.7372",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2714 20.9625L53.8508 26.1534",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.283 33.9112L64.9887 33.412",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8401 57.5481L23.5318 54.2629",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6768 62.0377L28.0973 56.8468",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6654 49.0891L16.9597 49.5883",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5106 48.4379C47.1106 44.137 54.1522 43.1411 59.8886 46.4531L73.0999 54.0806C80.1272 58.1378 82.5351 67.1243 78.4779 74.1516C76.4491 77.6656 73.1887 80.0239 69.5561 80.9972C65.9235 81.9706 61.9208 81.5584 58.4068 79.5296L45.1956 71.9021C39.4591 68.5901 36.8009 61.9941 38.2255 55.8599",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.359 51.8402C50.8807 50.4075 54.0777 50.309 56.7663 51.8613L69.9776 59.4888C74.0118 61.8179 75.399 66.9951 73.0698 71.0293C70.7407 75.0635 65.5635 76.4507 61.5293 74.1216L48.3181 66.4941C45.6295 64.9418 44.1163 62.1238 44.0962 59.2236",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5627 57.4572C48.4544 59.3767 46.075 60.1146 44.096 59.2236C43.9652 59.1643 43.836 59.0986 43.7094 59.0255L29.9972 51.1088L29.5515 50.1878L35.9071 47.1226L35.0012 44.1024L47.9943 51.604C48.1208 51.677 48.2424 51.7561 48.3591 51.8397C50.1203 53.1081 50.6709 55.5377 49.5627 57.4572Z",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5308 36.2616L43.9765 37.1826L33.9551 31.3967C33.8285 31.3237 33.707 31.2446 33.5903 31.161C31.8291 29.8926 31.2785 27.463 32.3867 25.5435C33.4949 23.624 35.8743 22.8861 37.8534 23.7771C37.9842 23.8364 38.1134 23.9021 38.2399 23.9752L48.9805 30.1763L49.8864 33.1964L43.5308 36.2616Z",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4384 34.5628C37.6564 36.2294 35.5078 37.3994 33.2096 38.0152C29.5771 38.9885 25.5744 38.5764 22.0604 36.5476L8.8491 28.9201C1.82178 24.8629 -0.58616 15.8764 3.47108 8.8491C7.52833 1.82177 16.5148 -0.58616 23.5421 3.47108L36.7534 11.0986C42.4899 14.4106 45.1482 21.0066 43.7235 27.1408",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.59 31.1605C31.0683 32.5932 27.8713 32.6918 25.1827 31.1395L11.9714 23.512C7.93725 21.1829 6.55005 16.0057 8.87918 11.9715C11.2083 7.93725 16.3855 6.55005 20.4197 8.87918L33.631 16.5067C36.3196 18.059 37.8328 20.8769 37.8529 23.7771",
    stroke: "#444CE7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBroken);
export default __webpack_public_path__ + "static/media/link-broken.56ef756640df1d3ac0349afbf298865a.svg";
export { ForwardRef as ReactComponent };